module.exports = __webpack_public_path__ + "img/banner-one8.8897819e.png";